var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 36.6666C7.89163 36.6666 7.46771 36.491 7.15515 36.1784C6.84259 35.8659 6.66699 35.4419 6.66699 34.9999V4.99992C6.66699 4.55789 6.84259 4.13397 7.15515 3.82141C7.46771 3.50885 7.89163 3.33325 8.33366 3.33325H31.667C32.109 3.33325 32.5329 3.50885 32.8455 3.82141C33.1581 4.13397 33.3337 4.55789 33.3337 4.99992V9.99992H30.0003V6.66659H10.0003V33.3333H30.0003V29.9999H33.3337V34.9999C33.3337 35.4419 33.1581 35.8659 32.8455 36.1784C32.5329 36.491 32.109 36.6666 31.667 36.6666H8.33366ZM30.0003 26.6666V21.6666H18.3337V18.3333H30.0003V13.3333L38.3337 19.9999L30.0003 26.6666Z",
    fill: "#186419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutBtn);
export default __webpack_public_path__ + "static/media/logoutBtn.adcf7bde5d2bc466c214d34be0b17144.svg";
export { ForwardRef as ReactComponent };